import { storage } from './firebase';

export const getURL = async (filePath: string) => {
  try {
    const url = await storage.ref(filePath).getDownloadURL();
    return url;
  } catch (error) {
    return '';
  }
};
